import { render, staticRenderFns } from "./ModalBuscarPlaca.vue?vue&type=template&id=3b33f591&"
import script from "./ModalBuscarPlaca.vue?vue&type=script&lang=js&"
export * from "./ModalBuscarPlaca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports